import createReducer from './create-reducer';

const initial = {
  page: 1,
  perPageCard: 10,
  perPageTable: 20,
  layout: 'card-layout', //todo make this come form layout strategy ?
  search: '',
  roleFacets: [],
  departmentFacets: [],
  pagerInfo: {},
  sort: null
};

const reducers = {
  UPDATE_USERS_LAYOUT: (state, value) => {
    return {
      ...state,
      ...{
        pagerInfo: value.pagerInfo,
        layout: value.layout
      }
    };
  },
  UPDATE_USERS_PAGE: (state, value) => {
    return { ...state, ...{ page: value.page, pagerInfo: value.pagerInfo } };
  },
  UPDATE_USERS_PERPAGE_CARD: (state, value) => {
    return { ...state, ...{ perPageCard: value } };
  },
  UPDATE_USERS_PERPAGE_TABLE: (state, value) => {
    return { ...state, ...{ perPageTable: value } };
  },
  UPDATE_USERS_SEARCH_TERM: (state, value) => {
    return { ...state, ...{ search: value, page: 1 } };
  },
  UPDATE_USERS_SORT: (state, value) => {
    return { ...state, ...{ sort: value, page: 1 } };
  },
  UPDATE_USERS_SORT: (state, value) => {
    return { ...state, ...{ sort: value } };
  },
  UPDATE_USERS_SEARCH_FACETS_ROLES: (state, value) => {
    return { ...state, ...{ roleFacets: value, page: 1 } };
  },
  UPDATE_USERS_SEARCH_FACETS_DEPARTMENTS: (state, value) => {
    return { ...state, ...{ departmentFacets: value, page: 1 } };
  }
};

export default createReducer(initial, reducers);
